export default "//yastatic.net/s3/distribution/pythia/frontend/_/afd11bd1ea018ec96767c2e699b0aea2.png";